module.exports = __webpack_public_path__ + "media/images/emblems/Premier-coat_of_arms-c6c291d034a34ed2228113325c427db3.svg";